import { useSyncExternalStore } from "react";

/**
 * The time now, to the minute, shared by everything on the page that says how long ago something was
 * (#6607). One timer for all of them, started by the first reader and stopped with the last, so a
 * conversation of a hundred messages does not run a hundred timers, and every message moves from "4m"
 * to "5m" together.
 */
export function useMinuteClock(): Date {
  return useSyncExternalStore(subscribe, readNow, readNow);
}

const TICK_MS = 60_000;
const listeners = new Set<() => void>();
let now = new Date();
let timer: ReturnType<typeof setInterval> | undefined;

function readNow(): Date {
  return now;
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  if (timer === undefined) {
    now = new Date();
    timer = setInterval(tick, TICK_MS);
  }
  return () => {
    listeners.delete(listener);
    if (listeners.size === 0 && timer !== undefined) {
      clearInterval(timer);
      timer = undefined;
    }
  };
}

function tick() {
  now = new Date();
  listeners.forEach((listener) => listener());
}
